import { computed } from 'vue';
import { Store } from 'vuex';

const useFeature = (store: Store<any>, feature: string) =>
  computed(() => {
    return store.getters['auth/isFeatureEnabled'](feature);
  });

export { useFeature };
